import { GroupType } from './types'
import React, { useState } from 'react'
import { addProductsToGroup } from './utility'
import { Box, Button } from '@mui/material'
import { ErrorDialog } from '../shared/ErrorDialog'
import { ProductSelectorDialog } from './ProductSelectorDialog'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProductsById } from '../../../api/masters.atoms'
import { ConfirmDialog } from 'shared/ui'

export function AddProductsToGroup({
  group,
  onAdded,
}: {
  group: GroupType
  onAdded: () => Promise<void>
}) {
  const [confirming, setConfirming] = useState(false)
  const [adding, setAdding] = useState(false)
  const [selectedIds, setSelectedIds] = useState<number[]>([])
  const [errors, setErrors] = useState<string[]>()

  const closeConfirm = () => {
    setConfirming(false)
  }
  const onConfirm = async () => {
    const { errors } = await addProductsToGroup(group, selectedIds)
    setErrors(errors?.map(({ message }) => message))
    closeConfirm()
    setAdding(false)
    await onAdded()
  }

  const onSelected = (pids: number[]) => {
    setSelectedIds(pids)
    setConfirming(true)
  }

  return (
    <>
      <Button onClick={() => setAdding(true)}>Add Products</Button>
      <ErrorDialog
        title="Error Adding Products"
        errors={errors}
        onClose={() => setErrors(undefined)}
      />
      <ProductSelectorDialog
        title="Select Products To Add To Group"
        cta="Add"
        onCommit={onSelected}
        onClose={() => setAdding(false)}
        shouldHide={!adding}
        filteredIds={group.products.map(({ id }) => id)}
      />
      <AddConfirmDialog
        productIds={selectedIds}
        onConfirm={onConfirm}
        onClose={closeConfirm}
        hidden={!confirming}
        group={group}
      />
    </>
  )
}

function AddConfirmDialog({
  productIds,
  onConfirm,
  onClose,
  hidden,
  group,
}: {
  group: GroupType
  productIds: number[]
  onConfirm: () => void
  onClose: () => void
  hidden: boolean
}) {
  const productsById = useAtomValue(allProductsById)
  const products = productIds.map((id) => productsById[id])

  return (
    <ConfirmDialog
      title={`Adding ${productIds.length} Products`}
      onConfirm={onConfirm}
      onClose={onClose}
      open={!hidden}
      cta="Add"
      cancel="Cancel"
    >
      <Box>
        <Box>{`Adding To: ${group?.name}`}</Box>
        <Box>
          {products.map(({ id, title }) => (
            <Box key={id} padding={'5px'}>
              {title}
            </Box>
          ))}
        </Box>
      </Box>
    </ConfirmDialog>
  )
}
